export default __webpack_public_path__ + "static/1-50125f797205f4fb085d79b38f474313.png";